export default __webpack_public_path__ + "static/media/TX_Elemental_Ice_Grimory.2d628846.png";